import { Download } from "lucide-react";
import { useEffect, useState } from "react";

import {
  hasInstallPrompt,
  isIos,
  isStandalone,
  showInstallPrompt,
  subscribeToInstallPrompt,
} from "../pwa";


export default function PwaControls() {
  const [installed, setInstalled] = useState(isStandalone());
  const [installAvailable, setInstallAvailable] = useState(hasInstallPrompt());
  const [message, setMessage] = useState("");

  useEffect(() => {
    const syncInstallState = () => {
      setInstalled(isStandalone());
      setInstallAvailable(hasInstallPrompt());
    };
    const unsubscribe = subscribeToInstallPrompt(syncInstallState);
    const displayMode = window.matchMedia("(display-mode: standalone)");
    displayMode.addEventListener("change", syncInstallState);
    return () => {
      unsubscribe();
      displayMode.removeEventListener("change", syncInstallState);
    };
  }, []);

  async function installApp() {
    setMessage("");
    if (installAvailable) {
      const accepted = await showInstallPrompt();
      setInstalled(accepted || isStandalone());
      if (!accepted) setMessage("Installazione annullata.");
      return;
    }
    if (isIos()) {
      setMessage(
        "Su iPhone: apri Condividi e scegli “Aggiungi alla schermata Home”.",
      );
    } else {
      setMessage("Usa il menu del browser e scegli “Installa app”.");
    }
  }

  if (installed) return null;

  return (
    <section className="pwa-controls" aria-label="Installazione app">
      <div className="pwa-control-buttons">
        <button className="pwa-control-button" onClick={() => void installApp()}>
          <Download size={15} />
          Installa app
        </button>
      </div>
      {message && <p className="pwa-control-message" role="status">{message}</p>}
    </section>
  );
}
